import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2ReleaseNoteService {
    constructor(private datatask: DataTaskService) {}

    public async getSettings(): Promise<P2ReleaseNoteSettingsGet> {
        return (await this.datatask.Post(225))[0];
    }

    public async listReleaseNotes(): Promise<P2ReleaseNoteItem[]> {
        return this.datatask.Post(221);
    }

    public async getReleaseNote(params: GetP2ReleaseNoteParams): Promise<P2ReleaseNoteEditGet> {
        return (await this.datatask.Post(222, params))[0];
    }

    public async listReleaseTypes(): Promise<P2ReleaseType[]> {
        return this.datatask.Post(223);
    }

    public async saveReleaseNote(edit: P2ReleaseNoteEditGet): Promise<void> {
        await this.datatask.Post(224, edit);
    }
}

export interface P2ReleaseNoteSettingsGet {
    searchtext: string;
    show: string;
}

export interface P2ReleaseNoteItem extends Item {
    item_state?: string;
}

export interface GetP2ReleaseNoteParams {
    p2_releasenote_keyno: string;
}

export interface P2ReleaseNoteEditGet {
    p2_releasenote_keyno: string;
    reg_datetime: string;
    public_note: string;
    video_url: string;
    show: '0' | '1';
    releasetype: string;
    internal_note: string;
    portal_user_name: string;
}

export interface P2ReleaseType {
    releasetype: string;
    releasetype_name: string;
}
